/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useReducer, useRef} from "react"
import {Col, Row} from "antd"
import {BaseDatePicker, BaseRangePicker} from "components/DateTimePicker"
import {BaseFilter} from "uiKit"
import styles from "./Filter.module.css"
import {formatCodeName} from "helpers"
import {useTranslation} from "react-i18next"
import ProgramSelect from "components/ProgramSelect"
import CampusSelect from "components/CampusSelect"
import {useAllCampuses, useModel} from "hooks"
import {isEmpty} from "lodash"

function reducer(state, action) {
    return {...state, ...action}
}

export function Filter(props) {
    const {t} = useTranslation(["studentServices", "common"])
    const model = useModel()
    const didInitCampusRef = useRef(false)
    const {campuses: allCampuses} = useAllCampuses()

    const initialState = {
        filter: {
            search: "",
            campuses: [],
            programs: [],
            date: null
        }
    }

    const [{filter}, dispatchState] = useReducer(reducer, initialState)

    const allUserCampusIds = useMemo(() => {
        const userProfiles = model.user?.profiles || []
        return userProfiles
            .flatMap((p) => (p.campuses || []).map(({id}) => Number(id)))
            .filter((id) => Number.isFinite(id) && id > 0)
    }, [model.user])

    useEffect(() => {
        if (didInitCampusRef.current) return
        if (!allCampuses.length) return
        if (!isEmpty(filter?.campuses)) return

        didInitCampusRef.current = true

        const selectedCampusValues = allUserCampusIds.length
            ? allCampuses.filter((c) => allUserCampusIds.includes(c.id))
            : allCampuses

        dispatchState({
            filter: {
                ...filter,
                campuses: selectedCampusValues
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allCampuses, allUserCampusIds, filter?.campuses])

    const onChangeFilter = (key, value) => {
        const newFilter = {...filter}
        newFilter[key] = value
        dispatchState({filter: newFilter})
    }

    return (
        <BaseFilter isShowFilterClear>
            <Row gutter={[40, 32]}>
                <Col span={12}>
                    <BaseDatePicker placeholder="Date Range" value="" getOptionLabel={formatCodeName} />
                </Col>
                <Col span={12}>
                    <CampusSelect
                        isMulti
                        placeholder="Campus"
                        displayOnlyCampusIds={allUserCampusIds}
                        value={filter.campuses}
                        onChange={(newValue) => {
                            // Prevent clearing all campuses
                            if (!newValue || newValue.length === 0) return
                            onChangeFilter("campuses", newValue)
                        }}
                    />
                </Col>
                <Col span={12}>
                    <ProgramSelect
                        value={filter.programs}
                        onChange={(newValue) => onChangeFilter("programs", newValue)}
                        isMulti
                        placeholder={t("filter.program")}
                    />
                </Col>
                <Col span={12}></Col>
                <Col span={12}>
                    <p className={styles.filter__title}>Student Status</p>
                    <BaseRangePicker placeholder={["Start Date", "End Date"]} value="" />
                </Col>
                <Col span={12}>
                    <p className={styles.filter__title}>Transactions</p>
                    <BaseRangePicker placeholder={["Start Date", "End Date"]} value="" />
                </Col>
            </Row>
        </BaseFilter>
    )
}
